<template>
  <section class="article-image">
    <ShapeBlobPaleOrange class="article-image__blob-left" />
    <ShapeBlobPaleGreen class="article-image__blob-right" />
    <KenticoResponsiveImage :src="image.url" :alt="image.description" class="article-image__image" :sizes="imageSizes" />
    <span class="article-image__caption">{{ caption }}</span>
  </section>
</template>

<script>
import ShapeBlobPaleOrange from '~/assets/images/events-community/shape-blob-pale-orange.svg?inline';
import ShapeBlobPaleGreen from '~/assets/images/testimonial/shape-blob-pale-green.svg?inline';
import { BREAKPOINTS, BREAKPOINT_MD, BREAKPOINT_LG } from '~/utils/constants';

export default {
  components: {
    ShapeBlobPaleOrange,
    ShapeBlobPaleGreen,
  },
  props: {
    image: {
      type: Object,
      required: true,
    },
    caption: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imageSizes: {
        default: [900, 750],
        sizes: [
          { breakpoint: BREAKPOINTS[BREAKPOINT_MD], width: 900, height: 750 },
          { breakpoint: BREAKPOINTS[BREAKPOINT_LG], width: 1200, height: 1000 },
        ],
      },
    };
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/components/_article-image.scss';
</style>
